import { render, staticRenderFns } from "./sup-add-report-dialog.vue?vue&type=template&id=34875f88&scoped=true"
import script from "./sup-add-report-dialog.vue?vue&type=script&lang=js"
export * from "./sup-add-report-dialog.vue?vue&type=script&lang=js"
import style0 from "./sup-add-report-dialog.vue?vue&type=style&index=0&id=34875f88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34875f88",
  null
  
)

export default component.exports